import React, { useState } from 'react'
import {
  Button,
  CardActionArea,
  CardContent,
  Container,
  Grid,
} from '@mui/material'
import { StyledCard } from '../../../components/StyledCard'
import { AlignedTypography } from '../../../components/AlignedTypography'
import { useGetProject } from '../../projects/hooks'
import { KioskProjectCard } from '../../../components/project/KioskProjectCard'
import { BackButton } from '../../../components/navigation/BackButton'
import { CameraFront } from '@mui/icons-material'
import { WebcamComponent } from '../../video/Webcam'
import { useNavigate, useParams } from 'react-router-dom'
import { ModalComponent } from '../../../components/ModalComponent'
import { useMutateMatchWorkerFace } from './hooks'

export const WorkerFacialRecognition = (props: any) => {
  const { id } = useParams()
  const { selectedLocation } = props
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [hasError, setHasError] = useState<boolean>(false)
  const [isFaceMatched, setIsFaceMatched] = useState<boolean>(false)
  const [workerPhotoRaw, setWorkerPhotoRaw] = useState<any | undefined>(null)
  const navigate = useNavigate()
  const { data: projectData } = useGetProject('project', id)
  const [isFaceMatchingInProgress, setIsFaceMatchingInProgress] =
    useState<boolean>(false)
  const { mutateAsync: matchWorkerFaceAsync } =
    useMutateMatchWorkerFace('worker')

  const onImageCaptureHandler = (image: any) => {
    setWorkerPhotoRaw(image)
  }
  const compareFaces = async () => {
    if (!workerPhotoRaw || !(workerPhotoRaw instanceof File)) {
      console.error('Invalid image data')
      return
    }
    setIsFaceMatched(false)
    setIsFaceMatchingInProgress(true)

    const formData = new FormData()
    formData.append('file', workerPhotoRaw) // Make sure this key is 'file'
    const data = {
      companyId: projectData.account,
    }
    formData.append('workerData', JSON.stringify(data))

    try {
      // Call the new backend endpoint for face matching
      const response = await matchWorkerFaceAsync(formData)
      if (response && response.worker) {
        navigate(`/projects/${id}/select-timesheet`, {
          replace: true,
          state: { worker: response.worker._id },
        })
      } else {
        setIsFaceMatched(false)
      }
    } catch (error) {
      setIsFaceMatched(true)
    } finally {
      setIsFaceMatchingInProgress(false)
    }
  }

  const onGetError = () => {
    setIsOpen(false)
    setHasError(true)
  }
  const handleClose = () => {
    setIsOpen(false)
    setIsFaceMatched(false)
  }

  const reTake = () => {
    setIsFaceMatched(false)
  }

  return (
    <>
      <Container maxWidth='lg' sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <BackButton steps={-3} />
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <KioskProjectCard
              project={projectData}
              selectedLocation={selectedLocation}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <StyledCard>
              <CardActionArea
                component={Button}
                onClick={() => setIsOpen(true)}>
                <CardContent>
                  <AlignedTypography
                    variant='h6'
                    gutterBottom
                    color='secondary'>
                    Worker Verification <CameraFront sx={{ ml: 2 }} />
                  </AlignedTypography>
                </CardContent>
              </CardActionArea>
              {!isOpen && hasError && (
                <p style={{ padding: 15 }}>Please allow webcam permission.</p>
              )}
            </StyledCard>
          </Grid>
        </Grid>
        <ModalComponent isOpen={isOpen} handleModalClose={handleClose}>
          <WebcamComponent
            action='compare'
            onError={onGetError}
            onImageCapture={onImageCaptureHandler}
            onReTake={reTake}
            isEnabled={isOpen}
            isFaceMatchingInProgress={isFaceMatchingInProgress}
          />
          <Button
            onClick={compareFaces}
            disabled={!workerPhotoRaw || isFaceMatchingInProgress}
            variant='contained'
            color='primary'>
            Find Me!
          </Button>
          {isFaceMatched && (
            <p style={{ color: 'red', paddingLeft: 25 }}>Face not matched!</p>
          )}
        </ModalComponent>
      </Container>
    </>
  )
}
